import { Link } from 'react-router-dom';

const featuredProducts = [
  {
    id: 'p004',
    name: '热久久户外加热马甲',
    description: '智能温控加热马甲，内置5片发热区域，三档温度调节，续航6-8小时，防风防水面料，户外工作者必备。',
    price: 299.9,
    categoryId: 'outdoor-heating',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20heated%20vest%20outdoor%20winter%20gear%20on%20clean%20warm%20background%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20technical%20outdoor%20apparel%20design%2C%20professional%20commercial%20shot%2C%20warm%20tones%20with%20technical%20aesthetic&width=600&height=600&seq=featured-p004&orientation=squarish',
  },
  {
    id: 'p001',
    name: '热久久经典保暖贴',
    description: '经典款自发热保暖贴，持续发热12小时，平均温度53°C，轻薄贴身，适合日常使用。采用铁粉氧化发热技术，安全环保。',
    price: 29.9,
    categoryId: 'warming-patches',
    imageUrl: 'https://readdy.ai/api/search-image?query=Single%20portable%20warming%20patch%20product%20on%20clean%20light%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20warm%20lighting%2C%20modern%20packaged%20heating%20pad%20design%2C%20professional%20commercial%20product%20shot%2C%20simple%20elegant%20composition%2C%20warm%20amber%20tones&width=600&height=600&seq=featured-p001&orientation=squarish',
  },
  {
    id: 'p007',
    name: '热久久碳纤维发热围巾',
    description: '碳纤维发热围巾，环绕式均匀加热，三档温度调节，亲肤面料，充电宝供电，时尚保暖两不误。',
    price: 159.9,
    categoryId: 'winter-gear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20carbon%20fiber%20heated%20scarf%20product%20on%20minimal%20warm%20cream%20surface%2C%20clean%20studio%20product%20photography%2C%20soft%20ambient%20lighting%2C%20stylish%20modern%20winter%20accessory%20design%2C%20professional%20commercial%20shot%2C%20warm%20tones%20composition&width=600&height=600&seq=featured-p007&orientation=squarish',
  },
  {
    id: 'p005',
    name: '热久久加热鞋垫',
    description: '智能控温加热鞋垫，无线遥控三档温度调节，续航10小时，适配各类鞋型，让双脚在寒冬中保持温暖。',
    price: 149.9,
    categoryId: 'winter-gear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smart%20heated%20insoles%20product%20on%20minimal%20cream%20backdrop%2C%20clean%20studio%20product%20photography%2C%20soft%20warm%20lighting%2C%20modern%20technical%20design%2C%20professional%20commercial%20shot%2C%20simple%20elegant%20composition&width=600&height=600&seq=featured-p005&orientation=squarish',
  },
];

export default function FeaturedProducts() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
              <a href="#featured-products">明星产品</a>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
              历经千万用户验证，口碑之选，品质保证
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
            {featuredProducts.map((product) => (
              <Link
                key={product.id}
                to={`/categories?tab=${product.categoryId}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
              >
                <div className="aspect-square overflow-hidden bg-background-100">
                  <img
                    src={product.imageUrl}
                    alt={`热久久${product.name}`}
                    title={`热久久${product.name} - 持久保暖产品`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">{product.name}</h3>
                  <p className="text-xs text-foreground-600 mb-3 line-clamp-2">{product.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-base font-bold text-accent-600 whitespace-nowrap">
                      &yen;{product.price}
                    </span>
                    <span className="text-xs text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap">
                      了解详情
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}